export default "__VITE_ASSET__35f18fa9__"